module.exports = __webpack_public_path__ + "static/media/fracture-set.cbf5e316.png";